module.exports = __webpack_public_path__ + "assets/img/news (28).d03dcded.png";